import mutations from './order-mutations';

export default {
  namespaced: true,
  state: {
    order: {}, // 查看的订单
    applicantIdsToChange: [], // 需要修改赴馆时间的申请人id集合
    newOrder: {
      applicant: [],
      departDate: '',
      expressList: [],
    }, // 新增的订单
    newOtaOrder: {
      // ota_id: 1,
      ota_store_id: null,
      ota_order_no: '',
      applicant_count: null,
    }, // 新的ota订单
    newFliggyOrder: {
      ota_sub_order_id: null,
      departDate: '',
      offline: null,
      applicant_set: [],
    }, // 飞猪新订单
  },
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/order/order-store.js